import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ReactComponent as AmberAlertTriangle } from '../../../assets/images/svg/amber-alert-triangle.svg';
import Modal from '../../Modal/Modal';
import ModalBody from '../../Modal/ModalBody';
import ModalButtons from '../../Modal/ModalButtons';
import Paragraph from '../../Paragraph/Paragraph';
import { pxToRem } from '../../../assets/styles/helper';
import themeColors from '../../../assets/styles/themeColors';

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${pxToRem(16)};

  svg {
    width: ${pxToRem(48)};
    height: ${pxToRem(48)};
    display: block;
  }
`;

const BodyTitle = styled.h3`
  font-size: ${pxToRem(18)};
  font-weight: 700;
  color: ${themeColors.colorTextPrimary};
  text-align: center;
  margin-bottom: ${pxToRem(8)};
`;

const SellFromHomeSsnLockedModal = ({ isOpen, close }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      size="lg"
      close={close}
      hideHeader
      verticalCenter
      isCenterModal
    >
      <ModalBody style={{ padding: '20px 40px' }}>
        <IconWrapper>
          <AmberAlertTriangle />
        </IconWrapper>
        <BodyTitle>{t('irs.ssn.error.SSNTooManyAttempts.title')}</BodyTitle>
        <Paragraph centerText>
          {t('irs.ssn.error.SSNTooManyAttempts.message')}
        </Paragraph>
        <ModalButtons
          isVertical
          textTransform="none"
          marginTop
          showOnlyPrimary
          primaryButtonProps={{
            label: t('common.close'),
            onClick: close,
          }}
        />
      </ModalBody>
    </Modal>
  );
};

SellFromHomeSsnLockedModal.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func,
};

export default SellFromHomeSsnLockedModal;
